const HTML_TAG_ENTRIES = [
  ["HTMLAnchorElement", "a"],
  ["HTMLAreaElement", "area"],
  ["HTMLAudioElement", "audio"],
  ["HTMLBaseElement", "base"],
  ["HTMLButtonElement", "button"],
  ["HTMLCanvasElement", "canvas"],
  ["HTMLDataElement", "data"],
  ["HTMLDataListElement", "datalist"],
  ["HTMLDetailsElement", "details"],
  ["HTMLDialogElement", "dialog"],
  ["HTMLDivElement", "div"],
  ["HTMLDListElement", "dl"],
  ["HTMLEmbedElement", "embed"],
  ["HTMLFieldSetElement", "fieldset"],
  ["HTMLFormElement", "form"],
  ["HTMLHRElement", "hr"],
  ["HTMLIFrameElement", "iframe"],
  ["HTMLImageElement", "img"],
  ["HTMLInputElement", "input"],
  ["HTMLLabelElement", "label"],
  ["HTMLLegendElement", "legend"],
  ["HTMLLIElement", "li"],
  ["HTMLLinkElement", "link"],
  ["HTMLMapElement", "map"],
  ["HTMLMetaElement", "meta"],
  ["HTMLMeterElement", "meter"],
  ["HTMLModElement", "del"],
  ["HTMLObjectElement", "object"],
  ["HTMLOListElement", "ol"],
  ["HTMLOptGroupElement", "optgroup"],
  ["HTMLOptionElement", "option"],
  ["HTMLOutputElement", "output"],
  ["HTMLParagraphElement", "p"],
  ["HTMLParamElement", "param"],
  ["HTMLPictureElement", "picture"],
  ["HTMLPreElement", "pre"],
  ["HTMLProgressElement", "progress"],
  ["HTMLQuoteElement", "blockquote"],
  ["HTMLScriptElement", "script"],
  ["HTMLSelectElement", "select"],
  ["HTMLSlotElement", "slot"],
  ["HTMLSourceElement", "source"],
  ["HTMLSpanElement", "span"],
  ["HTMLStyleElement", "style"],
  ["HTMLTableElement", "table"],
  ["HTMLTableSectionElement", "tbody"],
  ["HTMLTableCellElement", "td"],
  ["HTMLTemplateElement", "template"],
  ["HTMLTextAreaElement", "textarea"],
  ["HTMLTimeElement", "time"],
  ["HTMLTitleElement", "title"],
  ["HTMLTableRowElement", "tr"],
  ["HTMLTrackElement", "track"],
  ["HTMLUListElement", "ul"],
  ["HTMLVideoElement", "video"],
  ["HTMLHeadingElement", "h1"],
  ["HTMLBodyElement", "body"]
];
const DOM_EVENT_NAMES = ["click", "dblclick", "mousedown", "mouseenter", "mouseleave", "mousemove", "mouseout", "mouseover", "mouseup", "contextmenu", "keydown", "keypress", "keyup", "blur", "change", "focus", "focusin", "focusout", "input", "invalid", "reset", "search", "select", "submit", "drag", "dragend", "dragenter", "dragleave", "dragover", "dragstart", "drop", "copy", "cut", "paste", "abort", "canplay", "canplaythrough", "durationchange", "emptied", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting", "scroll", "resize", "load", "hashchange", "connected"];
const BROWSER_GLOBALS = ["window", "document", "Node", "Element", "HTMLElement", "DocumentFragment", "CustomEvent", "customElements", "NodeFilter", ...HTML_TAG_ENTRIES.map(([className]) => className)];
export {
  BROWSER_GLOBALS,
  DOM_EVENT_NAMES,
  HTML_TAG_ENTRIES
};
//# sourceMappingURL=config.js.map
